import { Component, computed, input, model, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PropertyModel } from '../../../../core/models/data/property.model';
import { NavItem } from '../../../../core/models/ui/profile-nav-item.model';
import { AddressPipe } from "../../../../core/pipes/address/address.pipe";
import { CommonChecks } from '../../../../core/utilities/common-checks.utilities';
import { SafeHtmlPipe } from "../../../../core/pipes/safe-html/safe-html.pipe";
import { AddressPipeSecondaryAddressFormat } from '../../../../core/enums/base.enums';
import { IfHasPermissionDirective } from '../../../../core/directives/if-has-permission/if-has-permission.directive';
import { TooltipDirective } from '../../../../core/directives/tooltip.directive';
import { AutoFitTextDirective } from '../../../../core/directives/auto-fit-text.directive';
import { PropertyPermission } from '../../../../core/enums/permissions.enums';
import { PropertyStatuses } from '../../../../core/enums/data.enums';
import { ResponsiveTabsComponent } from '../../../../parts/responsive-tabs/responsive-tabs.component';
import { StatusBadgeComponent } from '../../../../parts/status-badge/status-badge.component';

@Component({
  selector: 'ms-property-profile-header',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, AddressPipe, SafeHtmlPipe, IfHasPermissionDirective, TooltipDirective, AutoFitTextDirective, ResponsiveTabsComponent, StatusBadgeComponent],
  templateUrl: './property-profile-header.component.html',
  styleUrls: ['./property-profile-header.component.scss']
})
export class PropertyProfileHeaderComponent {
    public property = model<PropertyModel | null>();
    public isLoading = input(false);
    public navItems = input<NavItem[]>();
    public tabChanged = output<string>();
    public editRequested = output();
    public deactivateRequested = output();
    public reactivateRequested = output();
    public deleteRequested = output();

    public CommonChecks = CommonChecks;
    public AddressPipeSecondaryAddressFormat = AddressPipeSecondaryAddressFormat;
    public PropertyPermission = PropertyPermission;
    public PropertyStatuses = PropertyStatuses;

    public isActive = computed(() => this.property()?.status === PropertyStatuses.Active);
    public isDeactivated = computed(() => this.property()?.status === PropertyStatuses.Inactive);
    public isDeleted = computed(() => this.property()?.status === PropertyStatuses.Deleted);

    private readonly addressPipe = new AddressPipe();

    public addressTooltip = computed(() => {
        const address = this.property()?.addresses?.[0];
        if (!address) return '';
        return this.addressPipe
            .transform(address, AddressPipeSecondaryAddressFormat.NewLine)
            .replace(/<br\/>/g, '\n');
    });

    constructor() { }

    public onTabClick(tabId: string): void {
        this.tabChanged.emit(tabId);
    }
}
